import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const DEVICES = ["MOBILE", "DESKTOP"] as const;
export type typeDevice = (typeof DEVICES)[number];

const initialState = {
  isLoading: false,
  device: DEVICES[0] as typeDevice,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsLoading: (
      state,
      action: PayloadAction<typeof initialState.isLoading>
    ) => {
      state.isLoading = action.payload;
    },
    setDevice: (state, action: PayloadAction<typeof initialState.device>) => {
      state.device = action.payload;
    },
    resetApp: () => initialState,
  },
});

export const { setIsLoading, setDevice, resetApp } = appSlice.actions;

export default appSlice.reducer;
